import client from '../axios';
import { POST_SCHOOLCLOSINGREPORT, POST_SCHOOLCLOSINGREPORT_DETAIL, SCHOOLCLOSINGREPORT_DETAIL, SCHOOLCLOSINGREPORT_LIST } from './endpoint';

export const getSchoolClosingReportList = (params) => {
  return client.get(`${SCHOOLCLOSINGREPORT_LIST}/${params.yyyy}/${params.school_idx}`);
};

export const getSchoolClosingReportDetail = (params) => {
  return client.get(`${SCHOOLCLOSINGREPORT_DETAIL}/${params.yyyymm}/${params.school_idx}/${params.report_idx}`);
};

export const postSchoolClosingReportDetail = (data) => {
  const value = { ...data, submit_status: 1 };
  return client.post(POST_SCHOOLCLOSINGREPORT_DETAIL, value);
};

export const postTransientStorageSchoolClosingReportDetail = (data) => {
  const value = { ...data, submit_status: 0 };
  return client.post(POST_SCHOOLCLOSINGREPORT_DETAIL, value);
};

// 마감보고서 관리 - 교육원
export const postSchoolClosingReport = (params) => {
  console.log(params)
  return client.post(POST_SCHOOLCLOSINGREPORT.replace(':report_idx', params?.report_idx), { approve_yn: params?.approve_yn });
};
